
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { SpecialtyItemProps } from ".";
import { loading, update } from "store/specialty";

interface ApiSpecialtyUpdateInputProps extends SpecialtyItemProps {
}

type ApiSpecialtyUpdateOutputProps = OutputBaseProps<{ item: SpecialtyItemProps; }, ApiSpecialtyUpdateInputProps>

export const apiSpecialtyUpdate = async (data: ApiSpecialtyUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiSpecialtyUpdateOutputProps>("/api/specialty/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};